import { render, staticRenderFns } from "./CohortsEdit.vue?vue&type=template&id=35838d26&"
import script from "./CohortsEdit.vue?vue&type=script&lang=js&"
export * from "./CohortsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports